/* bundles-mix-match */
document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-mix-match]');
  if (!root) return;

  const configEl = root.querySelector('[data-mix-match-config]');
  const scentsEl = root.querySelector('[data-mix-match-scents]');
  const dialog = root.querySelector('[data-mix-match-dialog]');
  if (!configEl || !scentsEl || !dialog) return;

  let config;
  let scents;
  try {
    config = JSON.parse(configEl.textContent);
    scents = JSON.parse(scentsEl.textContent);
  } catch (error) {
    return;
  }

  const scentByHandle = scents.reduce((map, scent) => {
    map[scent.handle] = scent;
    return map;
  }, {});

  const singleCard = root.querySelector('[data-mix-match-single]');
  const packCards = root.querySelectorAll('[data-mix-match-pack]');
  const closeButton = dialog.querySelector('[data-mix-match-close]');
  const titleEl = dialog.querySelector('[data-mix-match-title]');
  const promoEl = dialog.querySelector('[data-mix-match-promo]');
  const shippingEl = dialog.querySelector('[data-mix-match-shipping]');
  const progressLabel = dialog.querySelector('[data-mix-match-progress-label]');
  const progressBar = dialog.querySelector('[data-mix-match-progress]');
  const grid = dialog.querySelector('[data-mix-match-grid]');
  const summaryRow = dialog.querySelector('[data-mix-match-summary]');
  const compareEl = dialog.querySelector('[data-mix-match-compare]');
  const priceEl = dialog.querySelector('[data-mix-match-price]');
  const saveEl = dialog.querySelector('[data-mix-match-save]');
  const addButton = dialog.querySelector('[data-mix-match-add]');
  const errorEl = dialog.querySelector('[data-mix-match-error]');
  const quantityInputs = document.querySelectorAll('.product-main-form input[name="quantity"]');
  const counterEl = document.getElementById('counter');

  let packSize = 2;
  let selections = [];
  let lastTrigger = null;
  let adding = false;

  if (dialog.parentElement !== document.body) {
    document.body.appendChild(dialog);
  }

  function formatMoney(cents) {
    const rounded = Math.round(cents);
    const format = config.moneyFormat || '${{amount}}';
    if (rounded % 100 === 0 || format.indexOf('{{amount_no_decimals}}') !== -1) {
      return format
        .replace('{{amount_no_decimals}}', String(Math.round(rounded / 100)))
        .replace('{{amount}}', String(Math.round(rounded / 100)))
        .replace('{{amount_with_comma_separator}}', String(Math.round(rounded / 100)));
    }
    const value = (rounded / 100).toFixed(2);
    return format.replace('{{amount}}', value).replace('{{amount_with_comma_separator}}', value);
  }

  function interpolate(template, vars) {
    return Object.keys(vars).reduce((result, key) => {
      return result.replace(new RegExp('\\[\\[' + key + '\\]\\]', 'g'), String(vars[key]));
    }, template || '');
  }

  function packSaveCents() {
    return Number(config.packSaves[packSize] || 0);
  }

  function selectedScents() {
    return selections.map((handle) => scentByHandle[handle]).filter(Boolean);
  }

  function compareCents() {
    const unit = Number(config.unitPrice || 0);
    if (unit > 0) return unit * packSize;
    return selectedScents().reduce((sum, scent) => sum + Number(scent.price || 0), 0);
  }

  function saleCents() {
    return Math.max(compareCents() - packSaveCents(), 0);
  }

  function setSingleQuantity() {
    quantityInputs.forEach((input) => {
      input.value = '1';
    });
    if (counterEl) counterEl.textContent = '1';
  }

  function activateSingle() {
    setSingleQuantity();
  }

  function scentCount(handle) {
    return selections.filter((item) => item === handle).length;
  }

  function remainingSlots() {
    return packSize - selections.length;
  }

  function renderGrid() {
    if (!grid) return;
    const room = remainingSlots();
    grid.querySelectorAll('[data-scent-handle]').forEach((card) => {
      const handle = card.getAttribute('data-scent-handle');
      const count = scentCount(handle);
      const selected = count > 0;
      const badge = card.querySelector('[data-scent-badge]');
      const qtyWrap = card.querySelector('[data-scent-qty]');
      const qtyValue = card.querySelector('[data-scent-qty-value]');
      const plusBtn = card.querySelector('[data-scent-qty-plus]');
      card.classList.toggle('is-selected', selected);
      if (badge) {
        if (selected) {
          badge.hidden = false;
          badge.textContent = count > 1 ? '×' + count : '1';
        } else {
          badge.hidden = true;
          badge.textContent = '';
        }
      }
      if (qtyWrap) qtyWrap.hidden = !selected;
      if (qtyValue) qtyValue.textContent = String(count || 1);
      if (plusBtn) plusBtn.disabled = room <= 0;
    });
  }

  function renderSummary() {
    if (!summaryRow) return;
    summaryRow.replaceChildren();
    const remaining = packSize - selections.length;

    selections.forEach((handle, index) => {
      const scent = scentByHandle[handle];
      if (!scent) return;
      if (index > 0) {
        const plus = document.createElement('span');
        plus.className = 'mix-match__summary-plus';
        plus.setAttribute('aria-hidden', 'true');
        plus.textContent = '+';
        summaryRow.appendChild(plus);
      }
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'mix-match__summary-remove';
      remove.setAttribute(
        'aria-label',
        interpolate(config.translations.removeScent, { name: scent.title })
      );
      remove.addEventListener('click', () => {
        selections.splice(index, 1);
        render();
      });
      const img = document.createElement('img');
      img.className = 'mix-match__summary-thumb';
      img.src = scent.image;
      img.alt = scent.title;
      img.width = 36;
      img.height = 36;
      remove.appendChild(img);
      summaryRow.appendChild(remove);
    });

    if (remaining > 0) {
      if (selections.length > 0) {
        const plus = document.createElement('span');
        plus.className = 'mix-match__summary-plus';
        plus.setAttribute('aria-hidden', 'true');
        plus.textContent = '+';
        summaryRow.appendChild(plus);
      }
      const empty = document.createElement('span');
      empty.className = 'mix-match__summary-empty';
      empty.textContent = interpolate(config.translations.addMore, { count: remaining });
      summaryRow.appendChild(empty);
    }
  }

  function renderTotals() {
    const compare = compareCents();
    const sale = saleCents();
    const save = packSaveCents();
    if (compareEl) compareEl.textContent = formatMoney(compare);
    if (priceEl) priceEl.textContent = formatMoney(sale);
    if (saveEl) saveEl.textContent = interpolate(config.translations.youSave, { amount: formatMoney(save) });
  }

  function renderProgress() {
    const selected = selections.length;
    if (progressLabel) {
      progressLabel.textContent = interpolate(config.translations.progress, {
        selected: selected,
        total: packSize,
      });
    }
    if (progressBar) {
      progressBar.max = packSize;
      progressBar.value = selected;
    }
  }

  function renderHeader() {
    const save = formatMoney(packSaveCents());
    if (titleEl) {
      titleEl.textContent = interpolate(config.translations.modalTitle, { size: packSize });
    }
    if (promoEl) {
      promoEl.textContent = interpolate(config.translations.modalPromo, {
        size: packSize,
        amount: save,
      });
    }
    if (shippingEl) {
      shippingEl.hidden = packSize !== 4;
    }
    if (addButton) {
      addButton.textContent = interpolate(config.translations.addPack, { size: packSize });
      addButton.disabled = selections.length !== packSize || adding;
    }
  }

  function render() {
    renderHeader();
    renderProgress();
    renderGrid();
    renderSummary();
    renderTotals();
    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }
  }

  function openModal(size, trigger) {
    packSize = Number(size);
    lastTrigger = trigger || null;
    const current = scents.find((scent) => scent.current && scent.available);
    selections = current ? [current.handle] : [];
    render();
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    if (closeButton) closeButton.focus();
  }

  function closeModal() {
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
      return;
    }
    dialog.removeAttribute('open');
    onDialogClose();
  }

  function isBackdropClick(event) {
    if (event.target === dialog) return true;
    const rect = dialog.getBoundingClientRect();
    return (
      event.clientX < rect.left ||
      event.clientX > rect.right ||
      event.clientY < rect.top ||
      event.clientY > rect.bottom
    );
  }

  function onDialogClose() {
    activateSingle();
    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
  }

  function addScent(handle) {
    const scent = scentByHandle[handle];
    if (!scent || !scent.available) return;
    if (selections.length >= packSize) return;
    selections.push(handle);
    render();
  }

  function removeScent(handle) {
    const index = selections.lastIndexOf(handle);
    if (index < 0) return;
    selections.splice(index, 1);
    render();
  }

  function clearScent(handle) {
    selections = selections.filter((item) => item !== handle);
    render();
  }

  function getSelectedPlanKey() {
    const sellingPlanInput = document.getElementById('selling_plan');
    if (!sellingPlanInput || !String(sellingPlanInput.value || '').trim()) return null;

    const cycleSelect = document.getElementById('sel_delivery_cycle');
    if (cycleSelect && cycleSelect.value) return String(cycleSelect.value);

    const pdpActive = document.querySelector(
      '.product-subscription-pdp .product-subscription-options__collapsable .product-subscription__item--active'
    );
    if (pdpActive && pdpActive.getAttribute('data-place')) {
      return String(pdpActive.getAttribute('data-place'));
    }

    const caseAActive = document.querySelector(
      '.product-subscription-wrapper.case-a .product-subscription__item--active[data-place]'
    );
    if (caseAActive && caseAActive.getAttribute('data-place') !== '0') {
      return String(caseAActive.getAttribute('data-place'));
    }

    return '1';
  }

  function sellingPlanForScent(scent, planKey) {
    if (!scent || !planKey || !scent.sellingPlans) return null;
    const planId = scent.sellingPlans[planKey];
    if (!planId) return null;
    const numeric = Number(planId);
    return Number.isFinite(numeric) && numeric > 0 ? numeric : null;
  }

  function buildCartItems() {
    const qtyByVariant = {};
    const scentByVariant = {};
    selectedScents().forEach((scent) => {
      qtyByVariant[scent.variantId] = (qtyByVariant[scent.variantId] || 0) + 1;
      scentByVariant[scent.variantId] = scent;
    });
    const packId = 'mm-' + Date.now();
    const packLabel = interpolate(config.translations.packProperty, { size: packSize });
    const planKey = getSelectedPlanKey();
    return Object.keys(qtyByVariant).map((variantId) => {
      const item = {
        id: Number(variantId),
        quantity: qtyByVariant[variantId],
        properties: {
          _variety_pack: packSize + '-pack',
          _variety_pack_id: packId,
          Pack: packLabel,
        },
      };
      const sellingPlan = sellingPlanForScent(scentByVariant[variantId], planKey);
      if (sellingPlan) item.selling_plan = sellingPlan;
      return item;
    });
  }

  async function addPackToCart() {
    if (adding || selections.length !== packSize) return;
    adding = true;
    addButton.disabled = true;
    addButton.textContent = config.translations.adding;
    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    try {
      const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(cartRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: buildCartItems() }),
      });

      if (!response.ok) {
        throw new Error('add_failed');
      }

      closeModal();
      if (window.robustCart) {
        window.robustCart.refreshCart();
        window.robustCart.openCart();
      } else {
        window.location.href = '/cart';
      }
    } catch (error) {
      if (errorEl) {
        errorEl.hidden = false;
        errorEl.textContent = config.translations.error;
      }
    } finally {
      adding = false;
      renderHeader();
    }
  }

  if (singleCard) {
    singleCard.addEventListener('click', () => {
      activateSingle();
    });
  }

  packCards.forEach((card) => {
    card.addEventListener('click', () => {
      openModal(card.getAttribute('data-mix-match-pack'), card);
    });
  });

  if (grid) {
    grid.addEventListener('click', (event) => {
      const card = event.target.closest('[data-scent-handle]');
      if (!card || card.hasAttribute('data-scent-unavailable')) return;
      const handle = card.getAttribute('data-scent-handle');
      if (event.target.closest('[data-scent-qty-plus]')) {
        addScent(handle);
        return;
      }
      if (event.target.closest('[data-scent-qty-minus]')) {
        removeScent(handle);
        return;
      }
      if (scentCount(handle) > 0) {
        clearScent(handle);
        return;
      }
      addScent(handle);
    });
  }

  if (closeButton) {
    closeButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      closeModal();
    });
  }

  dialog.addEventListener('click', (event) => {
    if (isBackdropClick(event)) closeModal();
  });

  dialog.addEventListener('close', onDialogClose);
  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeModal();
  });

  if (addButton) {
    addButton.addEventListener('click', () => {
      addPackToCart();
    });
  }

  activateSingle();
});
